export default __webpack_public_path__ + "static/media/logo-white.b9792ad9.png";